import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChanges, Inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ENTER, COMMA, I } from '@angular/cdk/keycodes';

import * as _ from 'underscore';

import { CallStage } from '../enums/CallStage';
import { PersonSearchService } from '../_services/person-search.service';
import { AggReqObjectHandlerService } from '../_services/agg-req-object-handler.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';
import { FilterParams } from '../common-interfaces-classes/FilterParams';
import { AggregationService } from '../_services/aggregation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../_services/local-storage.service';
import { ExtraInfo } from './ExtraInfo';
import { GlobalService } from '../_services/global.service';
import { MatrixFilter } from '../common-interfaces-classes/MatrixFilter';
import { StatsMatrixHandlerService } from '../_services/stats-matrix-handler.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DataService } from '../data.service';
import { SessionStorageService } from '../_services/session-storage.service';
import { TalentInsightsReqHandlerService } from '../_services/talent-insights-req-handler.service';
import { GeneralConstants } from '../constants/GeneralConstants';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SaveSearchModalComponent } from '../save-search-modal/save-search-modal.component';
import { SimilarCandidateService } from '../_services/similar-candidate.service';
import { SuggestedTitle } from "../openai/suggested-titles/suggested-titles.component";
import { DOCUMENT } from '@angular/common';
import { JdDataService } from '../jd-data.service';
import { CompanyInsightsService } from '../_services/company-insights.service';

@Component({
  selector: "app-person-search-filter",
  templateUrl: "./person-search-filter.component.html",
  styleUrls: ["./person-search-filter.component.scss"],
})
export class PersonSearchFilterComponent implements OnInit, OnDestroy, OnChanges {
  // Job title
  jobTitleInput: FormControl = new FormControl(null);
  jobTitleTopList: any;
  jobTitleSelectedList: any[] = [];
  jobTitleStatus = CallStage.CURRENT.toString();
  showJobTitleLoader: boolean = false;
  jobTitleList: any = [];

  // Past Job Title
  pastJobTitleInput: FormControl = new FormControl(null);
  pastJobTitleTopList: any;
  pastJobTitleSelectedList: any[] = [];
  pastJobTitleList: any = [];
  showPastJobTitleLoader: boolean = false;

  // location
  locationInput: FormControl = new FormControl(null);
  locationTopList: any = [];
  locationSelectedList: any = [];
  locationList: any = [];
  showLocationLoader = false;

  // company
  companyInput: FormControl = new FormControl(null);
  companySelectedList: any = [];
  companyList: any = [];
  companyStatus = CallStage.CURRENT.toString();
  companyTopList: any = [];
  showCompanyLoader = false;
  shouldShowStatusCompany = true;

  // industry
  industryStatus: string = 'Current';
  industrySelectedList: any = [];
  industryTopList: any = [];
  industryInput: FormControl = new FormControl(null);
  showIndustryLoader = false;
  industryList = [];

  // years of experience
  yearsofexperience: any = 'Total';
  yearsofexperienceFrom: FormControl = new FormControl(null);
  yearsofexperienceTo: FormControl = new FormControl(null);
  filterAppliedOnYearsOfExperience: boolean = false;
  dataSourceYearsOfExperience;

  // current years of experience
  currentfromyearsofexperience: FormControl = new FormControl(null);
  currenttoyearsofexperience: FormControl = new FormControl(null);
  filterAppliedOnCurrentYearsOfExperience: boolean = false;
  dataSourceCurrentYearsOfExperience;

  // education
  educationInput: FormControl = new FormControl(null);
  educationList: any = [];
  educationSelectedList: any = [];
  educationTopList: any = [];
  showEducationLoader = false;


  // Education Location
  schoolLocationInput: FormControl = new FormControl(null);
  schoolLocationList: any = [];
  schoolLocationSelectedList: any = [];
  schoolLocationTopList: any = [];
  showSchoolLocationLoader = false;

  // field of study
  fieldOfStudyInput: FormControl = new FormControl(null);
  fieldOfStudyList: any = [];
  fieldOfStudySelectedList: any = []
  fieldOfStudyTopList: any = [];
  showFieldOfStudyLoader = false;

  // gender
  gender: 'Male' | 'Female' | 'All' = 'All';
  isGenderSelected: boolean = false;
  isGenderSelectionDisabled = false;

  // School
  schoolInput: FormControl = new FormControl(null);
  schoolList: any = [];
  schoolSelectedList: any = [];
  schoolTopList: any = [];
  showSchoolLoader = false;

  // company size
  companySizeInput: FormControl = new FormControl(null);
  companySizeList: any = [];
  companySizeSelectedList: any = [];
  companysize: any = [];
  isCompanySizeSelected: boolean = false;
  companySizeOption: any = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1001-5000", "5001-10000", "10001+"]

  // skills
  skillsInput: FormControl = new FormControl(null);
  skillsList: any = [];
  skillsSelectedList: any = [];
  skillsTopList: any = [];
  showSkillLoader: boolean = false;

  // Likely To Move In
  filterLikelyToMoveIn: any = 'All';
  isLikelyToMoveInFilterSelected = false;
  candidateslikelytomove: String = null;

  // seniority
  seniority: any = [];
  seniorityList = GlobalService.seniorityLevels;

  // function
  functionStatus:any = 'Current';
  functionsList: any = [];
  functionSelectedList: any = [];
  functionsInput: FormControl = new FormControl(null);
  functionTopList = [];
  showFunctionsLoader = false;

  // changed jobs
  changedJobStatus: any = null;
  changedJobDuration: any = null;
  changedJobStartDuration: number = 0;
  changedJobEndDuration: number = 12;
  changedJobStatusMatrix: any = null;


  // keyword filter
  keywordSelectedList: any[] = [];
  keyword_input: FormControl = new FormControl(null);
  keywordlist: any[] = [];
  // keywordTopList: any = [];
  showKeywordLoader = false;

  filterData: FilterParams;
  reportsAggs: any = {};

  // Properties for mat-chip
  selectable = true;
  removable = true;

  // These properties are for data fetched through local storage whenver we are redirected from talent insights or different page
  extraInfo: ExtraInfo;

  // Keeping track of all subscriptions to unsubscribe later
  subscriptions: Subscription[] = [];

  searchHistoryRegion: string | null = null;
  // Typeahead
  private typeAheadSubject = new Subject<{ event: Event, type: string }>();
  minSearchLengthToActivateTypeaheads: number = 3;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  @Input() similarobject;
  @Input() redirectSource;
  @Input('aiSuggestion') aiSuggestion: SuggestedTitle[] = [];
  addOnBlur: any;
  isSimilarCanidate: boolean = false;

  // General constant - used to name all filters
  filterNames = GeneralConstants.FILTER_NAMES;

  // Properties for styling
  isPersonSearchListingPage = false;
  isReportDetails = false;
  filterType: string;
  searchKeyword: string;

  //keyword or boolean search input
  keywordInput: FormControl = new FormControl(null);
  showSearchKeywordLoader: Boolean = false;
  searchKeywordList: any;
  searchDisable: Boolean = true;
  filterValue: string;
  isSearchSaved: boolean = false;
  talentDiscoveryHistoryId: any;
  savedSearchDetails: any;
  successMessage: string;
  errorMessage: string;
  showregion: string;
  fullnameSelectedList: any = [];
  searchTitle: string;
  searchCompany: string;
  @Input() similarContinent;

  /**Type of distance */
  locationDistanceUnit: string = 'kilometers';
  /**Value of range of distance in location filter */
  locationDistanceRange:string = '20';

  locationDistanceUnitForFilterData: any = null;
  locationDistanceRangeForFilterData: any = null;
  locationDistanceRangefromAdvance: string = '20';
  wholeNumberForDistance: boolean = true;

  comingFromJd = false;
  tabType: string;

  get selectedContinent() {
    if(this.filterDataHandlerService.isCompanyInsightsPage) {
        return '';
    } else if(this.isReportDetails) {
      const talentRegion = this.localstorageservice.getItem('talentRegion');
      if (talentRegion) {
        return talentRegion;
      } else if (this.sessionStorageService.getItem('historyRegion')) {
        return this.sessionStorageService.getItem('historyRegion');
      } else {
        return this.localstorageservice.getItem('region');
      }
    } else if(this.isSimilarCanidate){
      return this.similarContinent;
    } else {
      if (this.sessionStorageService.getItem('historyRegion')) {
        return this.sessionStorageService.getItem('historyRegion');
      } else {
        return this.localstorageservice.getItem('region');
      }
    }

    }

  
  continentList:any[] = [{value: 'asia', type: 'location'}, {value: 'africa', type: 'location'}, {value: 'south america', type: 'location'}, {value: 'north america', type: 'location'}, {value: 'oceania', type: 'location'}];
  continentSelectedList: any[] = [];
  isCompanyInsightsDetails = false;
  
  searchChips: string;

  constructor(
    private personSearchService: PersonSearchService,
    private filterDataHandlerService: FilterDataHandlerService,
    private aggService: AggregationService,
    private route: ActivatedRoute,
    private localstorageservice: LocalStorageService,
    private statsMatrixHandlerService: StatsMatrixHandlerService,
    private dataService: DataService,
    private sessionStorageService: SessionStorageService,
    private talentInsightsReqHandler: TalentInsightsReqHandlerService,
    private aggReqObjectHandlerService: AggReqObjectHandlerService,
    private router: Router,
    private modalService: NgbModal,
    private similarCandidateService: SimilarCandidateService,
    @Inject(DOCUMENT) private document: Document,
    private jdDataService: JdDataService,
    private companyInsightsService: CompanyInsightsService
  ) {
    this.extraInfo = new ExtraInfo();
    this.filterData = filterDataHandlerService.fetchFilterData;
    // This is being handled in ngOnInit, can be reomoved after testing...
    // this.syncLocalDataWithFilterObject();
    if (!this.talentInsightsReqHandler.isTalentInsightsTab) {
      this.setReceivedData();
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
    }

    this.comingFromJd = this.jdDataService.isComingFromJobDescription;
  }

  ngOnInit() {

    this.filterDataHandlerService.fetchUpdatedContinent().subscribe((res) => {
      if (res.data) {
        this.getexpandrefresheddata(null)
      }
    })

    const s1 = this.filterDataHandlerService.fetchCompanyFilter().subscribe((res) => {
      if(res.company.length > 0){
        this.companySelectedList.push(res.company[0])
        this.companyStatus = CallStage.CURRENT_OR_PAST.toString();
        const event = {
          option:{
            value:{
              key:res.company[0].key, 
              chipkey:res.company[0].chipkey
            }
          }
        }
        this.selectedItem(event, 'company')
      }
    });
    this.subscriptions.push(s1);

    const fetchPersonSearchListingInsightsFilterSub = this.filterDataHandlerService.fetchPersonSearchListingInsightsFilter.subscribe(filterEvent => {
      const type = filterEvent.type;
      switch (type) {
        case 'yearsofexperience': {
          this.yearsofexperienceFrom.setValue(filterEvent.event);
          this.yearsofexperienceTo.setValue(filterEvent.event);
          this.applyFilter(type);
          break;
        }
        case 'currentyearsofexperience': {
          this.currentfromyearsofexperience.setValue(filterEvent.event);
          this.currenttoyearsofexperience.setValue(filterEvent.event);
          this.applyFilter(type);
          break;
        }
        case 'gender': {
          this.selectedItem({ target: { value: filterEvent.event == 'Men' ? 'Male' : 'Female' } }, type);
          break;
        }
        case 'seniority': {
          const seniorityData = _.uniq(this.seniority.concat(filterEvent.event.toLowerCase()));
          this.selectedItem({ value: seniorityData }, type);
          break;
        }
        default: {
          this.addToSelectedList(filterEvent.event, type);
        }
      }
    });
    this.subscriptions.push(fetchPersonSearchListingInsightsFilterSub);

    const recommendedCandidateSub = this.aggService.recCandidateDataEvent.subscribe(_res => { this.getExpandFilterData(); this.getTopList(); this.talentDiscoveryHistoryId = _res.talentdiscoveryhistoryid;  });
    this.subscriptions.push(recommendedCandidateSub);

    this.extraInfo = this.filterDataHandlerService.isRedirectFromTalentInsightsPage || this.filterDataHandlerService.isRedirectFromCompanyInsightsPage ? this.aggService.getRedirectDataV2() : this.aggService.getRedirectData();

    const matrixSelectionSub = this.statsMatrixHandlerService.matrixSelectionEvent.subscribe(matrixFilter => this.setMatrixFilterData(matrixFilter));
    this.subscriptions.push(matrixSelectionSub);

    const typeaheadSub = this.typeAheadSubject.pipe(debounceTime(500)).subscribe(({ event, type }) => {
      this.callTypeAheadSearch(event, type);
    });
    this.subscriptions.push(typeaheadSub);

    const filterDataUpdateSub = this.filterDataHandlerService.filterMethodEvent.subscribe(_el => {
      if (this.talentInsightsReqHandler.isTalentInsightsTab)
        this.localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
      else if(this.talentInsightsReqHandler.isCompanyInsightsTab)
      this.localstorageservice.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
    });
    this.subscriptions.push(filterDataUpdateSub);

    

    const yoeTypeUpdateEvent = this.filterDataHandlerService.yearsOfExperienceTypeEvent.subscribe(typeData => this.handleYOEUpdateEvent(typeData));
    this.subscriptions.push(yoeTypeUpdateEvent);
    // The above filter dataa from local storage will be used for state management
    if (this.talentInsightsReqHandler.isTalentInsightsTab) {
      
      const filterData = JSON.parse(this.localstorageservice.getItem(GeneralConstants.LS_KEYS.TALENT_FILTERS));
      if (!filterData || _.isEmpty(filterData)) {
        this.filterDataHandlerService.reset();
      } else {
        this.filterDataHandlerService.setFilterData(filterData);
      }
      this.filterData = this.filterDataHandlerService.fetchFilterData;
      if(this.filterData.jobTitleSelectedList.length > 0) {
        this.getFilterWiseDataToDisplay('jobtitle');
      } if(this.filterData.skillsSelectedList.length > 0) {
        this.getFilterWiseDataToDisplay('skills');
      } if(this.filterData.locationSelectedList.length > 0) {
        this.getFilterWiseDataToDisplay('location');
      }
      if(this.filterData.booleanquery && this.filterData.booleanquery !== "" && this.filterData.booleanquery !== "*"){
        this.keywordInput.patchValue(this.filterData.booleanquery);
        this.searchDisable = false;
      }
      this.syncLocalDataWithFilterObject();
    }

    if (this.talentInsightsReqHandler.isCompanyInsightsTab) {
      const filterData = this.localstorageservice.getItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS);
      if (!filterData || _.isEmpty(filterData)) {
        this.filterDataHandlerService.reset();
      } else {
        this.filterDataHandlerService.setFilterData(filterData);
      }
      this.filterData = this.filterDataHandlerService.fetchFilterData;
      this.syncLocalDataWithFilterObject();
    }
    this.checkGenderSelectionFromInsights();
    this.syncCompanySizeData();

    // Below method calls always need to be last method calls in ngOnInit
    this.filterAppliedOnYearsOfExperience = this.hasYOEExperienceData();
    this.filterAppliedOnCurrentYearsOfExperience = this.hasCurrentYOEExperienceData();

    this.isPersonSearchListingPage = this.filterDataHandlerService.isPersonSearchListingPage();
    this.isReportDetails = this.filterDataHandlerService.isReportDetailsPage;
    this.isCompanyInsightsDetails = this.filterDataHandlerService.isCompanyInsightsPage;

    this.shouldShowStatusCompany = this.getShouldShowStatusCompany();

    this.filterType = this.route.snapshot.queryParams['filtertype'];
    this.searchKeyword = this.route.snapshot.queryParams['keyword'];
    this.filterValue = this.route.snapshot.queryParams['filtervalue'];
    const searchSource = this.route.snapshot.queryParams['searchSource'];
    this.searchTitle = this.route.snapshot.queryParams['title'];
    this.searchCompany = this.route.snapshot.queryParams['company'];
    this.searchChips = this.route.snapshot.queryParams['searchedFrom'];
    this.tabType = this.route.snapshot.queryParams['type'];
    if ((this.filterType == 'searchKeyword' || (searchSource && searchSource == 'history-component')) || this.searchKeyword) {
      this.keywordInput.patchValue(this.searchKeyword);
      this.searchDisable = false;
    }
    if((this.searchKeyword || this.filterType) && !this.filterDataHandlerService.isRedirectFromTalentInsightsPage && !searchSource && !this.filterDataHandlerService.isRedirectFromCompanyInsightsPage && !this.jdDataService.isComingFromJobDescription)
    this.showQuickSearchFilters();
    this.showregion = this.localstorageservice.getItem('region');
    this.personSearchService.getGeoIpLocationOfUser.subscribe((response: any) => {
      this.showregion = this.localstorageservice.getItem('region') ? this.localstorageservice.getItem('region') : response.continent ? response.continent.toLowerCase() : 'asia';
      this.localstorageservice.setItem('region', this.showregion);
    });

     if(searchSource == "history-component"){
        this.searchHistoryRegion = this.sessionStorageService.getItem("historyRegion")
      }else{
        this.searchHistoryRegion = null;
      }

    if(this.similarCandidateService.isListingCalledFromSimilarCandidate) {
      this.isSimilarCanidate = true;
    }

    this.jdDataService.jdFilterUpdateObs.subscribe(() => this.getexpandrefresheddata(null));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.aiSuggestion && changes.aiSuggestion.currentValue && !changes.aiSuggestion.firstChange) {
      const s: SuggestedTitle[] = changes.aiSuggestion.currentValue;

      /**
       * Process the suggestion and return already applied chips with existing data/state
       * @param s
       * @param userSelectedList
       */
      const processSuggestion = (s: SuggestedTitle[], userSelectedList: any[]) => {
        return s.map(s => {
          const isAlreadyApplied = userSelectedList.find(j => j.chipkey == s.name && j.isSuggested)
          if (isAlreadyApplied) {
            return Object.assign({}, s, { isSuggested: true, suggestedTitle: s, isExcluded: isAlreadyApplied.isExcluded, isMandatory: isAlreadyApplied.isMandatory, chipkey: isAlreadyApplied.chipkey, chipvalue: isAlreadyApplied.chipvalue, key: isAlreadyApplied.key })
          } else {
            return Object.assign({}, s, { isSuggested: true, suggestedTitle: s, isExcluded: false, isMandatory: false, chipkey: s.name, chipvalue: s.name, key: s.name })
          }
        }).filter(Boolean);
      }

      // process title
      const titleSuggestion = s.filter(s => s.type == 'title');
      const userSelectedTitle = this.jobTitleSelectedList.filter(j => !j.isSuggested);
      const aiSuggestedTitles = processSuggestion(titleSuggestion, userSelectedTitle);
      const combiledTitles = [].concat(aiSuggestedTitles, userSelectedTitle);
      this.jobTitleSelectedList = _.uniq(combiledTitles, 'chipkey');

      // process skill
      const skillSuggestion = s.filter(s => s.type == 'skill');
      const userSelectedSkill = this.skillsSelectedList.filter(j => !j.isSuggested);
      const aiSuggestedSkills = processSuggestion(skillSuggestion, userSelectedSkill);
      const combiledSkills = [].concat(aiSuggestedSkills, userSelectedSkill);
      this.skillsSelectedList = _.uniq(combiledSkills, 'chipkey');


      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata('jobtitle');
      this.getexpandrefresheddata('skills');
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
    }
  }

  private getShouldShowStatusCompany() {
    return !this.extraInfo?.redirectData?.additionalFilters?.recentcompanyhires;
  }

  private checkGenderSelectionFromInsights() {
    const redirectDataTI = this.aggService.getTalentInsightsRedirectDataV2();
    // TODO : May need to handle same for company insights as well later
    if (this.extraInfo?.redirectSource === 'talent-insights' && ["male", "female"].includes(redirectDataTI.gender?.toLowerCase())) {
      this.gender = redirectDataTI.gender;
      this.isGenderSelected = true;
      this.isGenderSelectionDisabled = true;
      this.filterDataHandlerService.setGender(redirectDataTI.gender);
    }
  }

  private syncCompanySizeData() {
    const redirectDataTI = this.aggService.getTalentInsightsRedirectDataV2();
    // TODO : May need to handle same for company insights as well later
    const companySizeTI = "talent-insights" === this.extraInfo.redirectSource && redirectDataTI.companysize?.length ? _.flatten(redirectDataTI.companysize) : [];
    if (this.filterDataHandlerService.isPersonSearchListingPage() && companySizeTI?.length) {
      this.companySizeOption = companySizeTI;
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    // we are resetting the data so that we do not propogate the filter changes into other unwanted components
    this.filterDataHandlerService.reset();
    this.localstorageservice.setItem(GeneralConstants.LS_KEYS.TALENT_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));
    this.localstorageservice.setItem(GeneralConstants.LS_KEYS.COMPANY_FILTERS, JSON.stringify(this.filterDataHandlerService.fetchFilterData));

  }

  /**Calls whenever distance range or distance unit changes in location filter */
  // onChangeLocationRange(){
  //   this.filterData['distancefromselectedlocations'] = Number(this.locationDistanceRange);
  //   this.filterData['distancefromselectedlocationsmeasurementunit'] = this.locationDistanceUnit;

  //   this.filterDataHandlerService.setFilterData(this.filterData);
  //   this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });

  //   // this.aggReqObjectHandlerService.setStartIndex(0);
  //   // this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);

  //   // this.syncFilterData();
  //   console.log('-->',this.filterData)
  // }

  getFilterWiseDataToDisplay(filterName) {
    if (filterName === "jobtitle") {
      this.jobTitleStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport("jobtitle");
      this.jobTitleStatus === CallStage.CURRENT.toString() && this.getAggregationReport("current_jobtitle");
      this.jobTitleStatus === CallStage.PAST.toString() && this.getAggregationReport("pastjobtitle");
    }
    else if (filterName === "location") { this.getAggregationReport('location'); }
    else if (filterName === "skills") { this.getAggregationReport('skills'); }
    else if (filterName === "company") {
      this.companyStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('company');
      this.companyStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_company');
      this.companyStatus === CallStage.PAST.toString() && this.getAggregationReport('pastcompany');
    }
    else if (filterName === "company_size") {
      this.getAggregationReport('companysizes');
      this.getAggregationReport('current_companysizes');
    }
    else if (filterName === "industries" || filterName === "industry") {
      this.industryStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('industry');
      this.industryStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_industry');
      this.industryStatus === CallStage.PAST.toString() && this.getAggregationReport('pastindustry');
    }
    else if (filterName === "yearsofexperience") {
      this.yearsofexperience === "Total" && this.getAggregationReport('totalyearsofexperience');
      this.yearsofexperience === "Average" && this.getAggregationReport('averageyearsofexperience');
    }
    else if (filterName === "gender") { this.getAggregationReport('gender'); }
    else if (filterName === "education") { this.getAggregationReport('education'); }
    else if (filterName === "school") { this.getAggregationReport('school'); }
    else if (filterName === "field_of_study") { this.getAggregationReport('fieldofstudy'); }
    else if (filterName === "likely_to_move_in") { this.getAggregationReport('likelytomove'); }
    else if (filterName === "function") { 
      this.functionStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('function');
      this.functionStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_function');
      this.functionStatus === CallStage.PAST.toString() && this.getAggregationReport('pastfunction');  
    }
    else if (filterName === "currentyearsofexperience") { this.getAggregationReport('currentyearsofexperience'); }
    else if (filterName === 'schoollocation') {this.getAggregationReport('school_location')}
    else if (filterName === "seniority") { console.log("No need to call further APIs for ", filterName); }
    else if (filterName === "keyword") {
      console.log('Not calling any APIs on collapse of ', filterName);
      // this.getKeywordTypeaheads();
    }
    else if (filterName === "changedjobs") { }
    else if (filterName === this.filterNames.PAST_JOB_TITLE) { this.getAggregationReport(this.filterNames.PAST_JOB_TITLE); }
    else { console.log("invalid filterName for getFilterWiseDataToDisplay method - ", filterName); }
  }

  // private getKeywordTypeaheads() {
  //   this.personSearchService.getPersonSearchListing('a').subscribe((response: any) => {
  //     if (response.status === 'success') {
  //       this.keywordlist = response.data;
  //     }
  //   });
  // }

  getAggregationReport(aggregatetype: string) {
    const localRequestObject = this.aggService.getRequestWithFilters(this.extraInfo);
    if(this.talentInsightsReqHandler.isCompanyInsightsTab) {
      localRequestObject.companies =  this.companyInsightsService.fetchCompanyData?.alternative_names?.length > 0 ? this.companyInsightsService.fetchCompanyData.alternative_names.concat([this.companyInsightsService.fetchCompanyData.name]): [this.companyInsightsService.fetchCompanyData.name];
      localRequestObject['calledvia'] = "companypages"
    }
    const type = this.route.snapshot.queryParams['type'];
    const searchSource = this.route.snapshot.queryParams['searchSource'];


    this.addTypeAheads(aggregatetype, localRequestObject);
    if(this.similarCandidateService?.isListingCalledFromSimilarCandidate || type == 'quick-search' || ((searchSource && searchSource == 'history-component') && this.searchKeyword)) {
      localRequestObject['calledfrom'] = 'listing';
    }
    this.personSearchService
      .getTotalAggs(localRequestObject)
      .subscribe((response) => {
        if (response.status == "success") {
          this.reportsAggs[aggregatetype] = response.data.aggregations[aggregatetype];
          const yoeTypes = [
            "currentyearsofexperience",
            "totalyearsofexperience",
          "averageyearsofexperience",
          ];
          if (yoeTypes.includes(aggregatetype)) { this.createYOEData(response.data.aggregations, aggregatetype); }
        }
      })
      .add(() => this.getTopList());
  }

  applyFilter(type) {
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);

    if (type === 'yearsofexperience') {
      const fromExperience = parseInt(this.yearsofexperienceFrom.value);
      const toExperience = parseInt(this.yearsofexperienceTo.value);
      if (!isNaN(fromExperience) && !isNaN(toExperience)) {
        if (fromExperience <= toExperience) {
          this.filterAppliedOnYearsOfExperience = true;
        } else {
          console.error('fromyearsofexperience should be less than toyearsofexperience. type = ', type);
        }
        this.yearsofexperience === "Total" ? this.getAggregationReport("totalyearsofexperience") : this.getAggregationReport("averageyearsofexperience");
      }
    } else if (type === 'currentyearsofexperience') {
      const currentfromExperience = parseInt(this.currentfromyearsofexperience.value);
      const currenttoExperience = parseInt(this.currenttoyearsofexperience.value);
      if (!isNaN(currentfromExperience) && !isNaN(currenttoExperience)) {
        if (currentfromExperience <= currenttoExperience) {
          this.filterAppliedOnCurrentYearsOfExperience = true;
        } else {
          console.error('fromyearsofexperience should be less than toyearsofexperience. type = ', type);
        }
        this.getAggregationReport("currentyearsofexperience");
      }
    }

    this.aggReqObjectHandlerService.setStartIndex(0);
    // We need both calls here for proper working
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.getexpandrefresheddata(type);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({methodName: "applyFilter"});
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
  }

  private createYOEData(aggregationResponse, aggregatetype: string) {
    const aggregations = Object.assign({}, aggregationResponse);
    const CharForYearsOfExperience = [];
    aggregations[aggregatetype] && aggregations[aggregatetype].forEach((x) => {
      let dataObj = {
        label: `${x.key}`,
        value: x.doc_count,
        tooltext: `${x.key} <br> Talent count: ${x.doc_count}`,
      };
      CharForYearsOfExperience.push(dataObj);
    });

    if (aggregatetype === "averageyearsofexperience" || aggregatetype === "totalyearsofexperience") {
      this.dataSourceYearsOfExperience = {
        dataFormat: "json",
        height: 14,
        width: 14,
        chart: {
          renderAt: "chart-container",
          paletteColors: "#F4AB33",
          captionFontColor: "#F4AB33",
          showPercentValues: "1",
          yAxisNameFontColor: "#F4AB33",
          legendPosition: "right",
          theme: "fusion",
          labelFont: "Poppins",
          legendItemFont: "Poppins",
          baseFont: "Poppins",
          baseFontSize: "11",
          drawanchors: "0",
          showToolTip: "1",
          showValues: "0",
          showYAxisValues: "0",
        },
        data: CharForYearsOfExperience,
      };
    } else if (aggregatetype === "currentyearsofexperience") {
      this.dataSourceCurrentYearsOfExperience = {
        type: "bar2d",
        dataFormat: "json",
        height: 14,
        width: 14,
        chart: {
          renderAt: "chart-container",
          paletteColors: "#F4AB33",
          captionFontColor: "#F4AB33",
          showPercentValues: "1",
          yAxisNameFontColor: "#F4AB33",
          theme: "fusion",
          labelFont: "Poppins",
          legendItemFont: "Poppins",
          baseFont: "Poppins",
          baseFontSize: "11",
          showYAxisValues: "0",
          drawanchors: "0",
          showToolTip: "1",
          showValues: "0",
        },
        data: CharForYearsOfExperience
      };
    }
  }

  clearFilters(type: string) {
    const resetAITitleList = [];
    this.filterDataHandlerService.reset(type);
    this.filterData = this.filterDataHandlerService.fetchFilterData;
    if (type === "all" || type === "jobtitle") {
      this.jobTitleSelectedList.forEach(value => {
        if (value && value.isSuggested) {
          value.suggestedTitle.selected = false;
          resetAITitleList.push(value);
        }
      });
      this.jobTitleSelectedList = [];
      this.jobTitleStatus = CallStage.CURRENT.toString();
    }
    if (type === "all" || type === "location") {
      this.locationSelectedList = [];
      this.locationDistanceRange = '20';
      this.locationDistanceUnit='kilometers'
    }
    if (type === "all" || type === "company") {
      this.companySelectedList = [];
      this.companyStatus = CallStage.CURRENT.toString();
    }
    if (type === "all" || type === "industry") {
      this.industrySelectedList = [];
      this.industryStatus = CallStage.CURRENT.toString();
    }
    if (type === "all" || type === "education") { this.educationSelectedList = []; }
    if (type === "all" || type === "fieldofstudy") { this.fieldOfStudySelectedList = []; }
    if (type === "all" || type === "gender") {
      this.gender = 'All';
      this.isGenderSelected = false;
      const matrixFilter = new MatrixFilter('gender', {
        target: {
          value: "All"
        }
      });
      // If gender selection is disabled then we should not be able to edit the gender data
      !this.isGenderSelectionDisabled && this.statsMatrixHandlerService.emitFilterMatrixObject(matrixFilter);
      this.checkGenderSelectionFromInsights();
    }
    if (type === "all" || type === "school") { this.schoolSelectedList = []; }
    if (type === "all" || type === "companysize") {
      this.companysize = [];
      this.isCompanySizeSelected = false;
    }
    if (type === "all" || type === "yearsofexperience") {
      this.yearsofexperienceFrom.setValue(null);
      this.yearsofexperienceTo.setValue(null);
      this.filterAppliedOnYearsOfExperience = false;
      this.yearsofexperienceFrom.setValidators([Validators.required, Validators.min(0)]);
      this.yearsofexperienceTo.setValidators([Validators.required, Validators.min(0)]);
      this.yearsofexperience = 'Total';
    }
    if (type === "all" || type === "skills") {
      this.skillsSelectedList.forEach(value => {
        if (value && value.isSuggested) {
          value.suggestedTitle.selected = false;
          resetAITitleList.push(value);
        }
      });
      this.skillsSelectedList = [];
    }
    if (type === "all" || type === "likelytomovein") {
      this.filterLikelyToMoveIn = 'All';
      this.candidateslikelytomove = 'All';
      this.isLikelyToMoveInFilterSelected = false;
      const matrixFilter = new MatrixFilter('likelytomovein', {
        target: {
          value: this.isLikelyToMoveInFilterSelected ? 'Yes' : 'All'
        }
      });
      this.statsMatrixHandlerService.emitFilterMatrixObject(matrixFilter);
    }
    if (type === "all" || type === "seniority") { this.seniority = []; }
    if (type === "all" || type === "functions") { this.functionSelectedList = []; }
    if (type === "all" || type === "keyword") { this.keywordSelectedList = []; }
    if (type === "all" || type === "currentyearsofexperience") {
      this.currentfromyearsofexperience.setValue(null);
      this.currenttoyearsofexperience.setValue(null);
      this.filterAppliedOnCurrentYearsOfExperience = false;
      this.currentfromyearsofexperience.setValidators([Validators.required, Validators.min(0)]);
      this.currenttoyearsofexperience.setValidators([Validators.required, Validators.min(0)]);
    }
    if (type === "yearsofexperience") { this.getAggregationReport("totalyearsofexperience"); }
    if (type === "currentyearsofexperience") { this.getAggregationReport("currentyearsofexperience"); }
    // if (type === "all" || type === "changedjobs") { this.changedJobStatus = 'All'; }
    if (type === "all" || type === "changedjobs") {
      this.changedJobStatus = 'All';
      this.changedJobStatusMatrix = 'All';
      this.changedJobStartDuration = 0;
      this.changedJobEndDuration = 12;
      this.changedJobDuration = null;
      this.aggService.changeJobResetEmit();
    }
    if (type === "all" || type === this.filterNames.PAST_JOB_TITLE) { this.pastJobTitleSelectedList = []; }
    if (type == 'search' || type == 'all') {
      this.keywordInput.patchValue(null); this.searchKeyword = ''; this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          keyword: null,
          filtertype: null,
          filtervalue: null
        },
        queryParamsHandling: 'merge',
      });
    }

    if (type === "all" || type === 'schoollocation') { this.schoolLocationSelectedList = []; }

    if(type === 'all' || type === 'locationRange'){
      this.locationDistanceRange = '20';
      this.locationDistanceUnit = 'kilometers';
    }

    this.filterDataHandlerService.pushAISuggestionData(resetAITitleList);
    this.getexpandrefresheddata(type);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({methodName: "clearFilters"});
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
  }

  /**
   *
   * This method is called each time get person search recommended candidate API is called.
   *
   */
  getTopList() {
    // I have removed the code to delete the typeahead params because we are not editing the original object anyways
    this.jobTitleTopList = (this.jobTitleStatus == CallStage.CURRENT.toString() ? this.reportsAggs?.current_jobtitle : this.jobTitleStatus == CallStage.PAST.toString() ? this.reportsAggs?.pastjobtitle : this.reportsAggs?.jobtitle) || [];
    this.jobTitleTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryjobtitles ? this.jobTitleTopList.filter(j => !this.extraInfo.redirectData?.mandatoryjobtitles.includes(j.key)) : this.jobTitleTopList;
    this.jobTitleTopList = this.jobTitleTopList.filter(jobTitle => !this.jobTitleSelectedList.some(selectedJobTitle => selectedJobTitle.chipkey.toLowerCase() == jobTitle.key.toLowerCase())).slice(0, 5);

    this.pastJobTitleTopList = this.reportsAggs && this.reportsAggs[this.filterNames.PAST_JOB_TITLE] ?
      this.reportsAggs[this.filterNames.PAST_JOB_TITLE] : [];
    this.pastJobTitleTopList = this.aggService.manadatoryApplicable(this.extraInfo) && this.extraInfo.redirectData?.mandatorypastjobtitles ? this.pastJobTitleTopList.filter(j => !this.extraInfo.redirectData.mandatorypastjobtitles.includes(j.key)) : this.pastJobTitleTopList;
    this.pastJobTitleTopList = this.pastJobTitleTopList.filter(pastJobTitle => !this.pastJobTitleSelectedList.some(selectedPastJobTitle => selectedPastJobTitle.chipkey.toLowerCase() == pastJobTitle.key.toLowerCase()))?.slice(0, 5);

    this.locationTopList = this.reportsAggs?.location ? this.reportsAggs?.location : [];
    this.locationTopList = this.extraInfo.redirectSource == 'talent-insights' && this.extraInfo.redirectData?.location ? this.locationTopList.filter(l => !this.extraInfo.redirectData?.location.includes(l.key)) : this.extraInfo.redirectSource == 'company-insights' && this.extraInfo.redirectData?.locations ? this.locationTopList.filter(l => !this.extraInfo.redirectData.locations?.includes(l.key)) : this.locationTopList;
    this.locationTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatorylocations ? this.locationTopList.filter(l => !this.extraInfo.redirectData?.mandatorylocations?.includes(l.key)) : this.locationTopList;
    this.locationTopList = this.locationTopList.filter(location => !this.locationSelectedList.some(selectedLocation => selectedLocation.chipkey.toLowerCase() == location.key.toLowerCase())).slice(0, 5);

    this.skillsTopList = this.reportsAggs?.skills ? this.reportsAggs?.skills : [];
    this.skillsTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.skills ? this.skillsTopList.filter(s => !this.extraInfo.redirectData?.skills?.includes(s.key)) : this.skillsTopList;
    this.skillsTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryskills ? this.skillsTopList.filter(s => !this.extraInfo.redirectData?.mandatoryskills?.includes(s.key)) : this.skillsTopList;
    this.skillsTopList = this.skillsTopList.filter(skill => !this.skillsSelectedList.some(selectedSkill => selectedSkill.chipkey.toLowerCase() == skill.key.toLowerCase())).slice(0, 5);

    this.companyTopList = (this.companyStatus == 'Current' ? this.reportsAggs?.current_company : this.companyStatus == 'Past' ? this.reportsAggs?.pastcompany : this.reportsAggs?.company) || [];
    this.companyTopList = this.extraInfo.redirectSource == 'talent-insights' && this.extraInfo.redirectData?.mandatorycompanies ? this.companyTopList?.filter(c => !this.extraInfo.redirectData?.mandatorycompanies?.includes(c.key)) : this.companyTopList;
    this.companyTopList = this.extraInfo.redirectSource == 'company-insights' && this.extraInfo?.redirectData?.winningtalent ? this.companyTopList?.filter(c => !this.extraInfo.redirectData?.winningtalent?.includes(c.key)) : this.extraInfo.redirectSource == 'company-insights' && this.extraInfo.redirectData?.losingtalent ? this.companyTopList?.filter(c => !this.extraInfo?.redirectData?.losingtalent?.includes(c.key)) : this.companyTopList;
    this.companyTopList = this.extraInfo.redirectSource == 'company-insights' && this.extraInfo?.redirectData?.name ? this.companyTopList?.filter(c => c.key != this.extraInfo.redirectData?.name) : this.companyTopList;
    this.companyTopList = this.companyTopList.filter(company => !this.companySelectedList?.some(selectedCompany => selectedCompany.chipkey.toLowerCase() == company.key.toLowerCase())).slice(0, 5);

    this.industryTopList = (this.industryStatus == 'Current' ? this.reportsAggs?.current_industry : this.industryStatus == 'Past' ? this.reportsAggs?.pastindustry : this.reportsAggs?.industry) || [];
    this.industryTopList = (this.extraInfo.redirectSource == 'talent-insights') && this.extraInfo.redirectData?.mandatoryindustries ? this.industryTopList?.filter(i => !this.extraInfo.redirectData?.mandatoryindustries?.includes(i.key)) : this.industryTopList;
    this.industryTopList = this.industryTopList?.filter(industry => !this.industrySelectedList?.some(selectedIndustry => selectedIndustry.chipkey.toLowerCase() == industry.key.toLowerCase())).slice(0, 5);

    this.educationTopList = this.reportsAggs?.education ? this.reportsAggs?.education : [];
    this.educationTopList = this.educationTopList?.filter(education => !this.educationSelectedList?.some(selectedEducation => selectedEducation?.chipkey?.toLowerCase() == education?.key?.toLowerCase())).slice(0, 5);

    this.schoolLocationTopList = this.reportsAggs?.school_location ? this.reportsAggs?.school_location : [];
    this.schoolLocationTopList = this.schoolLocationTopList?.filter(education => !this.schoolLocationSelectedList?.some(selectedEducation => selectedEducation?.chipkey?.toLowerCase() == education?.key?.toLowerCase())).slice(0, 5);
    
    this.fieldOfStudyTopList = this.reportsAggs?.fieldofstudy ? this.reportsAggs?.fieldofstudy : [];
    this.fieldOfStudyTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryeducationalmajors ? this.fieldOfStudyTopList?.filter(f => !this.extraInfo.redirectData?.mandatoryeducationalmajors?.includes(f.key)) : this.fieldOfStudyTopList;
    this.fieldOfStudyTopList = this.fieldOfStudyTopList?.filter(fieldOfStudy => !this.fieldOfStudySelectedList?.some(selectedFieldOfStudy => selectedFieldOfStudy?.chipkey?.toLowerCase() == fieldOfStudy?.key?.toLowerCase())).slice(0, 5);

    // this.keywordTopList = this.reportsAggs?.keyword ? this.reportsAggs?.keyword : [];
    // TODO : Confirm with Snehal about how to handle this case
    // this.fieldOfStudyTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryeducationalmajors ? this.fieldOfStudyTopList?.filter(f => !this.extraInfo.redirectData?.mandatoryeducationalmajors?.includes(f.key)) : this.fieldOfStudyTopList;
    // this.keywordTopList = this.keywordTopList?.filter(keyword => !this.keywordSelectedList?.some(selectedKeyword => selectedKeyword?.chipkey?.toLowerCase() == keyword?.key?.toLowerCase())).slice(0, 5);

    this.schoolTopList = this.reportsAggs?.school ? this.reportsAggs?.school : [];
    this.schoolTopList = (this.extraInfo.redirectSource == 'talent-insights' || this.extraInfo.redirectSource == 'company-insights') && this.extraInfo.redirectData?.mandatoryschools ? this.schoolTopList?.filter(s => !this.extraInfo.redirectData?.mandatoryschools?.includes(s.key)) : this.schoolTopList;
    this.schoolTopList = this.schoolTopList.filter(school => !this.schoolSelectedList?.some(selectedSchool => selectedSchool?.chipkey?.toLowerCase() == school?.key?.toLowerCase())).slice(0, 5);
    
    this.functionTopList = (this.functionStatus == 'Current' ? this.reportsAggs?.current_function : this.functionStatus == 'Past' ? this.reportsAggs?.pastfunction : this.reportsAggs?.function) || [];
    this.functionTopList = this.extraInfo.redirectSource == 'talent-insights' && this.extraInfo.redirectData?.functions ? this.functionTopList?.filter(f => !this.extraInfo?.redirectData?.functions?.includes(f.key))  : this.functionTopList;
   // this.functionTopList = this.extraInfo.redirectSource == 'company-insights' && this.extraInfo.redirectData?.mandatoryfunctions ? this.functionTopList?.filter(f => !this.extraInfo.redirectData?.mandatoryfunctions?.includes(f?.key)) : this.functionTopList;
    this.functionTopList = this.functionTopList?.filter(func => !this.functionSelectedList?.some(selectedfunction => selectedfunction?.chipkey?.toLowerCase() == func?.key?.toLowerCase())).slice(0, 5);
    //console.log("data", data);
  }

  companySizeHandler(event) {
    let value = event.value;
    this.companysize = _.without(this.companysize, "All")
    value = _.without(value, "All")
    if (value.length == 8) {
      this.companysize = value;
      this.companysize.push("All");
    } else {
      this.companysize = value;
    }
  }

  seniorityHandler(event) {
    let value = event.value;
    this.seniority = _.without(this.seniority, "All")
    value = _.without(value, "All")
    if (value.length == 10) {
      this.seniority = value;
      this.seniority.push("All")
    } else {
      this.seniority = _.uniq(this.seniority.concat(value));
    }
  }


  selectedItem(event, type) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });

    switch (type) {
      case 'jobtitle': {
        this.jobTitleList = []
        if(this.talentInsightsReqHandler.isTalentInsightsTab){
          this.jobTitleSelectedList.push({ key: event.option.value.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: event.option.value.key});
        }else{
          this.jobTitleSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        }
        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, 'chipkey');
        this.jobTitleInput.reset();
        break;
      }
      case this.filterNames.PAST_JOB_TITLE: {
        this.pastJobTitleList = []
        if(this.talentInsightsReqHandler.isTalentInsightsTab){
          this.pastJobTitleSelectedList.push({ key: event.option.value.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        }else{
          this.pastJobTitleSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        }
        this.pastJobTitleSelectedList = _.uniq(this.pastJobTitleSelectedList, 'chipkey');
        this.pastJobTitleInput.reset();
        break;
      }
      case 'skills': {
        this.skillsList = []
        this.skillsSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'chipkey');
        this.skillsInput.reset();
        break;
      }
      case 'company': {
        this.companyList = []
        this.companySelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.companySelectedList = _.uniq(this.companySelectedList, 'chipkey');
        this.companyInput.reset();
        break;
      }
      case 'industry': {
        this.industryList = []
        this.industrySelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'chipkey');
        this.industryInput.reset();
        break;
      }
      case 'fieldofstudy': {
        this.fieldOfStudyList = []
        this.fieldOfStudySelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'chipkey');
        this.fieldOfStudyInput.reset();
        break;
      }
      case 'companysize': {
        this.companySizeHandler(event)
        // this.companysize = event.value;
        this.isCompanySizeSelected = this.companysize.length > 0;
        break;
      }
      case 'school': {
        this.schoolList = []
        this.schoolSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'chipkey');
        this.schoolInput.reset();
        break;
      }
      case 'education': {
        this.educationList = []
        this.educationSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.educationSelectedList = _.uniq(this.educationSelectedList, 'chipkey');
        this.educationInput.reset();
        break;
      }
      case 'gender': {
        this.gender = event.target.value;
        this.isGenderSelected = this.gender != 'All';
        this.statsMatrixHandlerService.emitFilterMatrixObject(new MatrixFilter(type, event));
        break;
      }
      case 'seniority': {
        this.seniorityHandler(event)
        break;
      }
      case 'location': {
        // if(this.isCompanyInsightsDetails) {
        //   const iscontinent = this.continentList.find(x=>x.value== event.option.value.key);
        //   if(iscontinent) {
        //     this.continentSelectedList.push(iscontinent.value);
        //   }
        // }
        this.locationList = []
        this.locationSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.locationSelectedList = _.uniq(this.locationSelectedList, 'chipkey');
        this.locationInput.reset();
        break;
      }
      case 'likelytomovein': {
        this.filterLikelyToMoveIn = event.target.value;
        this.isLikelyToMoveInFilterSelected = this.filterLikelyToMoveIn === 'Yes';
        this.candidateslikelytomove = this.filterLikelyToMoveIn;
        this.statsMatrixHandlerService.emitFilterMatrixObject(new MatrixFilter(type, event));
        break;
      }
      case 'function': {
        this.functionsList = []
        this.functionSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.functionSelectedList = _.uniq(this.functionSelectedList, 'chipkey');
        this.functionsInput.reset();
        break;
      }
      case 'changedJobs': {
        this.changedJobStatus = 'no';
        this.changedJobDuration = parseInt(event.target.value);
        this.changedJobStartDuration = this.changedJobDuration;
        this.changedJobEndDuration = 12;
        this.aggService.changeJobResetEmit();
        // this.isChangedJobsSelected = (this.changedJobStatus === 'yes')
        break;
      }
      case 'keyword': {
        this.keywordSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.keywordSelectedList = _.uniq(this.keywordSelectedList, 'chipkey');
        this.keyword_input.reset();
        break;
      }
      case 'schoollocation': {
        this.schoolLocationList = []
        this.schoolLocationSelectedList.push({ ...event.option.value, isExcluded: false, isMandatory: false, chipkey: event.option.value.key });
        this.schoolLocationSelectedList = _.uniq(this.schoolLocationSelectedList, 'chipkey');
        // this.keywordlist = this.keywordlist.filter((el: any) => !this.keywordSelectedList.some((kw: any) => kw.chipkey == el));
        this.schoolLocationInput.reset();
        break;
      }
      case 'locationRange' : {
        this.locationDistanceRangeForFilterData = this.locationDistanceRange;
        this.locationDistanceUnitForFilterData = this.locationDistanceUnit;
        break;
      }
    }
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
    this.document.documentElement.scrollTop = 0;

  }

  getexpandrefresheddata(type) {
    //for company filter
    if (document.getElementById('collapseFour')?.classList.contains('show') && type != 'company') {
      this.companyStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('company');
      this.companyStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_company');
      this.companyStatus === CallStage.PAST.toString() && this.getAggregationReport('pastcompany');
    }
    //for jobtitle
    if (document.getElementById('collapseOne')?.classList.contains('show') && type != 'jobtitle') {
      this.jobTitleStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport("jobtitle");
      this.jobTitleStatus === CallStage.CURRENT.toString() && this.getAggregationReport("current_jobtitle");
      this.jobTitleStatus === CallStage.PAST.toString() && this.getAggregationReport("pastjobtitle");
    }
    //for past jobtitle
    if (document.getElementById('collapsePastJobTitle')?.classList.contains('show') && type !== this.filterNames.PAST_JOB_TITLE) {
      this.getAggregationReport(this.filterNames.PAST_JOB_TITLE);
    }
    //for location
    if (document.getElementById('collapseTwo')?.classList.contains('show') && type != 'location') {
      this.getAggregationReport('location');
    }
    //for skills
    if (document.getElementById('collapseThree')?.classList.contains('show') && type != 'skills') {
      this.getAggregationReport('skills');
    }
    //for industries
    if (document.getElementById('collapseSix')?.classList.contains('show') && type != 'industry') {
      this.industryStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('industry');
      this.industryStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_industry');
      this.industryStatus === CallStage.PAST.toString() && this.getAggregationReport('pastindustry');
    }
    //for education
    if (document.getElementById('collapseTwelve')?.classList.contains('show') && type != 'education') {
      this.getAggregationReport('education');
    }
    //for school
    if (document.getElementById('collapseFourteen')?.classList.contains('show') && type != 'school') {
      this.getAggregationReport('school');
    }
    // for field of study
    if (document.getElementById('collapseFifteen')?.classList.contains('show') && type != 'fieldofstudy') {
      this.getAggregationReport('fieldofstudy');
    }
    // for functions
    if (document.getElementById('collapseEighteen')?.classList.contains('show') && type != 'function') {
      this.functionStatus === CallStage.CURRENT_OR_PAST.toString() && this.getAggregationReport('function');
      this.functionStatus === CallStage.CURRENT.toString() && this.getAggregationReport('current_function');
      this.functionStatus === CallStage.PAST.toString() && this.getAggregationReport('pastfunction');  
    }
    // for years of experience
    if (document.getElementById('collapseSeven')?.classList.contains('show') && type !== 'yearsofexperience') {
      this.yearsofexperience === "Total" ?
        this.getAggregationReport('totalyearsofexperience') :
        this.getAggregationReport('averageyearsofexperience');
    }
    // for years of experience
    if (document.getElementById('collapeSevenCurrent')?.classList.contains('show') && type !== 'currentyearsofexperience') {
      this.getAggregationReport('currentyearsofexperience');
    }
     // for years of experience
     if(document.getElementById('schoollocation')?.classList.contains('show') && type !== 'schoollocation') {
      this.getAggregationReport('school_location');
    }
  }

  filterByStatus(event, type) {
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "filterByStatus" });
    if (type === 'jobtitle') { this.jobTitleStatus = event.target.value; }
    if (type === 'company') { this.companyStatus = event.target.value; }
    if (type === 'industry') { this.industryStatus = event.target.value; }
    if (type === 'yearsofexperience') {
      this.yearsofexperience = event.target.value;
      this.filterDataHandlerService.emitYearsOfExperienceType({
        yoeType: this.yearsofexperience,
        emmitedFrom: GeneralConstants.COMPONENT_NAME.PERSON_SEARCH_FILTER
      });
    }

    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getFilterWiseDataToDisplay(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "selectedItem" });
  }

  getCompanyLogoForCompanyChips(companyList: Array<string>) { 
    if(!companyList || !companyList.length) return;
    const updatedCompanyList = companyList.map(companyName => {
      const name = companyName.split(".searchastext");
      return (name[0]).toLowerCase();
    }).filter(Boolean);
    
    this.personSearchService.getCompanyLogo({ companynames: updatedCompanyList }).subscribe((res: any) => {
      this.companySelectedList?.length && this.companySelectedList.map(company => {
        if (res && res.message?.length) {
          res.message.map(logosData => {
            if (((logosData.key).toLowerCase() === (company.chipkey).toLowerCase()) || ((logosData.key).toLowerCase() === (company.key).toLowerCase()) ) {
              company['companylogo'] = logosData?.companylogo;
            }
          })
        }
      })
    })
  }

  addToSelectedList(item, type, from: any = null) {
    switch (type) {
      case 'jobtitle': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.jobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          if(this.talentInsightsReqHandler.isTalentInsightsTab){
            this.jobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
          }else{
            this.jobTitleSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
          }
        }
        this.jobTitleSelectedList = _.uniq(this.jobTitleSelectedList, 'chipkey');
        this.jobTitleInput.reset();
        break;
      }
      case this.filterNames.PAST_JOB_TITLE: {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.pastJobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          if(this.talentInsightsReqHandler.isTalentInsightsTab){
            this.pastJobTitleSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
          }else{
           this.pastJobTitleSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
          }
        }
        this.pastJobTitleSelectedList = _.uniq(this.pastJobTitleSelectedList, 'chipkey');
        this.pastJobTitleInput.reset();
        break;
      }
      case 'location': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.locationSelectedList.push({ key: item.key + ".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.locationSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.locationSelectedList = _.uniq(this.locationSelectedList, 'chipkey');
        this.locationInput.reset();
        break;
      }
      case 'skills': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.skillsSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.skillsSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.skillsSelectedList = _.uniq(this.skillsSelectedList, 'chipkey');
        this.skillsInput.reset();
        break;
      }
      case 'company': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.companySelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key});
          this.getCompanyLogoForCompanyChips([item.key]);
        } else {
          this.companySelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.companySelectedList = _.uniq(this.companySelectedList, 'chipkey');
        this.companyInput.reset();
        break;
      }
      case 'industry': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.industrySelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.industrySelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.industrySelectedList = _.uniq(this.industrySelectedList, 'chipkey');
        this.industryInput.reset();
        break;
      }
      case 'fieldofstudy': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.fieldOfStudySelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.fieldOfStudySelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.fieldOfStudySelectedList = _.uniq(this.fieldOfStudySelectedList, 'chipkey');
        this.fieldOfStudyInput.reset();
        break;
      }
      case 'school': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.schoolSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.schoolSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.schoolSelectedList = _.uniq(this.schoolSelectedList, 'chipkey');
        this.schoolInput.reset();
        break;
      }
      case 'education': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.educationSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.educationSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.educationSelectedList = _.uniq(this.educationSelectedList, 'chipkey');
        this.educationInput.reset();
        break;
      }
      case 'function': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.functionSelectedList.push({ key: item.key + '.searchastext', isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.functionSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.functionSelectedList = _.uniq(this.functionSelectedList, 'chipkey');
        this.functionsInput.reset();
        break;
      }
      case 'keyword': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.keywordSelectedList.push({ key: item.key, isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.keywordSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.keywordSelectedList = _.uniq(this.keywordSelectedList, 'chipkey');
        this.keyword_input.reset();
        break;
      }
      case 'schoollocation': {
        if (from == 'enter') {
          item = { key: item.toLowerCase(), doc_count: 0 }
          this.schoolLocationSelectedList.push({ key: item.key+".searchastext", isExcluded: false, isMandatory: false, chipkey: item.key });
        } else {
          this.schoolLocationSelectedList.push({ ...item, isExcluded: false, isMandatory: false, chipkey: item.key });
        }
        this.schoolLocationSelectedList = _.uniq(this.schoolLocationSelectedList, 'chipkey');
        this.schoolLocationInput.reset();
        break;
      }
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    if(this.isCompanyInsightsDetails) {
      this.getTopList();
    }
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList" });
    this.document.documentElement.scrollTop = 0;

  }

  excludeFilterItem(item, type) {
    if (type === "jobtitle") {
      this.jobTitleSelectedList = this.jobTitleSelectedList.map(jt => jt.key == item ? { ...jt, isExcluded: !jt.isExcluded } : jt);
    } else if (type === "location") {
      this.locationSelectedList = this.locationSelectedList.map(loc => loc.key == item ? { ...loc, isExcluded: !loc.isExcluded } : loc);
    } else if (type === "company") {
      this.companySelectedList = this.companySelectedList.map(company => company.key == item ? { ...company, isExcluded: !company.isExcluded } : company);
    } else if (type === this.filterNames.PAST_JOB_TITLE) {
      this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.map(jt => jt.key == item ? { ...jt, isExcluded: !jt.isExcluded } : jt);
    } else if (type === "industry") {
      this.industrySelectedList = this.industrySelectedList.map(ind => ind.key == item ? { ...ind, isExcluded: !ind.isExcluded } : ind);
    }else if(type == 'schoollocation'){
      this.schoolLocationSelectedList = this.schoolLocationSelectedList.map(sl => sl.key == item ? { ...sl, isExcluded: !sl.isExcluded } : sl);
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "excludeFilterItem" });
  }

  removeChip(value, type) {
    const inputElements: NodeListOf<Element> = document.querySelectorAll('.mat-input-element');
    inputElements.forEach((element: Element) => {
      (element as HTMLInputElement).blur();
    });
    switch (type) {
      case 'jobtitle':
        this.jobTitleSelectedList = this.jobTitleSelectedList.filter(item => item.key !== value.key);
        break;
      case this.filterNames.PAST_JOB_TITLE:
        this.pastJobTitleSelectedList = this.pastJobTitleSelectedList.filter(item => item.key !== value.key);
        break;
      case 'skills':
        this.skillsSelectedList = this.skillsSelectedList.filter(item => item.key !== value.key);
        break;
      case 'company':
        this.companySelectedList = this.companySelectedList.filter(item => item.key !== value.key);
        break;
      case 'industry':
        this.industrySelectedList = this.industrySelectedList.filter(item => item.key !== value.key);
        break;
      case 'fieldofstudy':
        this.fieldOfStudySelectedList = this.fieldOfStudySelectedList.filter(item => item.key !== value.key);
        break;
      case 'companysize':
        if (value === "All") {
          this.companysize = [];
        } else {
          this.companysize = this.companysize.filter(item => item !== value);
        }
        break;
      case 'school':
        this.schoolSelectedList = this.schoolSelectedList.filter(item => item.key !== value.key);
        break;
      case 'education':
        this.educationSelectedList = this.educationSelectedList.filter(item => item.key !== value.key);
        break;
      case 'location':
        this.locationSelectedList = this.locationSelectedList.filter(item => item.key !== value.key);
        break;
      case 'functions':
        this.functionSelectedList = this.functionSelectedList.filter(item => item.key !== value.key);
        break;
      case 'seniority':
        if (value === "All")
          this.seniority = [];
        else
          this.seniority = this.seniority.filter(item => item !== value);
        break;
      case 'keyword':
        this.keywordSelectedList = this.keywordSelectedList.filter(item => item.key != value.key);
        this.keyword_input.patchValue(null);
        break;
      case 'schoollocation':
        this.schoolLocationSelectedList = this.schoolLocationSelectedList.filter(item => item.key !== value.key);
      default:
        console.log('removeChip not implemented for - ', type);
        break;
    }
    // set data for suggested chips deselection
    if (value && value.isSuggested) {
      value.suggestedTitle.selected = false;
      this.filterDataHandlerService.pushAISuggestionData([value]);
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "removeChip" });
  }

  mandatoryFilterItem(item, type) {
    if (type === "jobtitle") {
      this.jobTitleSelectedList = this.jobTitleSelectedList.map(jt => jt.key == item ? { ...jt, isMandatory: !jt.isMandatory } : jt);
    } else if (type === "skills") {
      this.skillsSelectedList = this.skillsSelectedList.map(skill => skill.key == item ? { ...skill, isMandatory: !skill.isMandatory } : skill);
    }
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(type);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "mandatoryFilterItem" });
  }

  typeAheadSearch(event, type) {
    const requestObject = this.aggService.getRequestWithFilters();
    if (requestObject && requestObject['aggregatetype']) {
      delete requestObject['aggregatetype'];
    }
    const region = this.selectedContinent;
    const searchValue = (event.target as HTMLInputElement).value.trim();

    if (searchValue.length < this.minSearchLengthToActivateTypeaheads) return;
    switch (type) {

      case 'jobtitle': {
        requestObject['typeahead'] = this.jobTitleStatus == 'Current or Past' ? 'typeahead_jobtitle' : this.jobTitleStatus == 'Current' ? 'typeahead_currentjobtitle' : 'typeahead_pastjobtitle';
        requestObject['input'] = searchValue;
        this.showJobTitleLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle', region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.jobTitleList = response.data;
            this.showJobTitleLoader = false
          }
        });
        break;
      }
      case this.filterNames.PAST_JOB_TITLE: {
        requestObject['typeahead'] = 'typeahead_pastjobtitle';
        requestObject['input'] = searchValue;
        this.showPastJobTitleLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'jobtitle', region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.pastJobTitleList = response.data;
            this.showPastJobTitleLoader = false;
          }
        });
        break;
      }
      case 'skills': {
        requestObject['typeahead'] = 'typeahead_skills';
        requestObject['input'] = searchValue;
        this.showSkillLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'skill', region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.skillsList = response.data;
            this.showSkillLoader = false
          }
        });
        break;
      }
      case 'company': {
        requestObject['typeahead'] = this.companyStatus == 'Current or Past' ? 'typeahead_company' : this.companyStatus == 'Current' ? 'typeahead_currentcompany' : 'typeahead_pastcompany';
        requestObject['input'] = searchValue;
        this.showCompanyLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'company', region).subscribe(async (response: any) => {
          if (response.status == 'success' && response.data) {
            const companyList = response.data.length ? await this.personSearchService.getCompanyLogo({ companynames: response.data.map(c => c.value)}).toPromise() : { message: [] };
            this.companyList = companyList.message;
            this.showCompanyLoader = false
          }
        });
        break;
      }
      case 'industry': {
        requestObject['typeahead'] = this.industryStatus == 'Current or Past' ? 'typeahead_industry' : this.industryStatus == 'Current' ? 'typeahead_currentindustry' : 'typeahead_pastindustry';
        requestObject['input'] = searchValue;
        this.showIndustryLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'industry', region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.industryList = response.data;
            this.showIndustryLoader = false
          }
        });
        break;
      }
      case 'fieldofstudy': {
        requestObject['typeahead'] = 'typeahead_fieldofstudy';
        requestObject['input'] = searchValue;
        this.showFieldOfStudyLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'fieldofstudy', region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.fieldOfStudyList = response.data;
            this.showFieldOfStudyLoader = false
          }
        });
        break;
      }
      case 'companysize': {
        requestObject['typeahead'] = this.jobTitleStatus == 'All' ? 'typeahead_companysize' : 'typeahead_currentcompanysize';
        requestObject['input'] = searchValue;
        this.personSearchService.getPersonSearchListing(searchValue, null, region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            const rangeValue = (range) => {
              const match = range.match(/(\d+)/g);
              const start = parseInt(match[0]);
              return Math.floor(start / 10);
            };

            this.companySizeList = response.data.sort((a, b) => {
              const aValue = rangeValue(a.key);
              const bValue = rangeValue(b.key);
              return aValue - bValue;
            });
          }
        });
        break;
      }
      case 'education': {
        requestObject['typeahead'] = 'typeahead_education';
        requestObject['input'] = searchValue;
        this.showEducationLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'education',region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.educationList = response.data;
            this.showEducationLoader = false
          }
        });
        break;
      }
      case 'school': {
        requestObject['typeahead'] = 'typeahead_school';
        requestObject['input'] = searchValue;
        this.showSchoolLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'school',region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.schoolList = response.data;
            this.showSchoolLoader = false
          }
        });
        break;
      }
      case 'location': {
        requestObject['typeahead'] = 'typeahead_location';
        requestObject['input'] = searchValue;
        this.showLocationLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'location',region ).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.locationList = response.data;
            // if(this.isCompanyInsightsDetails) {
            // //  this.locationList.push(this.continentList);
            //   this.locationList = _.flatten(this.locationList);
            //   this.locationList = this.locationList.filter((x) =>{ return x.value.toLowerCase().includes(searchValue.toLowerCase()) });
            // }
           this.showLocationLoader = false
          }
        });
        break;
      }
      case 'functions': {
        requestObject['typeahead'] = 'typeahead_functions';
        requestObject['input'] = searchValue;
        this.showFunctionsLoader = true;        
        this.personSearchService.getPersonSearchListing(searchValue, 'function', region).subscribe((response: any) => {
          if (response.status == 'success' && response.data) {
            this.functionsList = response.data;
            this.showFunctionsLoader = false
          }
        });
        break;
      }
      case 'keyword': {
        this.showKeywordLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, null, region).subscribe((response: any) => {
          if (response.status == 'success') {
            this.keywordlist = response.data;
            this.showKeywordLoader = false
          }
        });
        break;
      }
      case 'schoollocation': {
        this.showSchoolLocationLoader = true;
        this.personSearchService.getPersonSearchListing(searchValue, 'school_location', region).subscribe((response: any) => {
          if (response.status == 'success') {
            this.schoolLocationList = response.data;
            this.showSchoolLocationLoader = false
          }
        });
        break;
      }

      
    }
  }

  // Call this function whenever the user types something
  onTypeAheadSearch(event: Event, type: string) {
    // Emit the event and type as an object through the typeAheadSubject to apply debounce
    this.typeAheadSubject.next({ event, type });
  }

  shouldShowFilter(filter: string) {
    return this.filterDataHandlerService.shouldShowFilter(filter);
  }

  shouldShowStatus() {
    return this.filterDataHandlerService.shouldShowStatus();
  }

  private syncFilterData() {
    const globalFilterData = this.filterDataHandlerService.fetchFilterData;

    this.filterData.jobTitleSelectedList = _.clone(this.jobTitleSelectedList, true);
    this.filterData.jobTitleStatus = this.jobTitleStatus;

    this.filterData.pastJobTitleSelectedList = _.clone(this.pastJobTitleSelectedList, true);

    this.filterData.skillsSelectedList = _.clone(this.skillsSelectedList, true);
    // if(this.isCompanyInsightsDetails) {
    //   const locations = this.locationSelectedList.filter(x=>(x.chipkey!='asia' && x.chipkey!= 'africa' && x.chipkey!= 'north america' && x.chipkey!= 'south america' && x.chipkey!= 'oceania'));
    //   this.filterData.locationSelectedList = _.clone(locations, true);
    //   this.filterData.continentstobeincluded = this.continentSelectedList;
    // } else {
      this.filterData.locationSelectedList = _.clone(this.locationSelectedList, true);
     // this.filterData.continentstobeincluded = globalFilterData.continentstobeincluded;
  //  }


    this.filterData.companySelectedList = _.clone(this.companySelectedList, true);
    this.filterData.companyStatus = this.companyStatus;

    this.filterData.industrySelectedList = _.clone(this.industrySelectedList, true);
    this.filterData.industryStatus = this.industryStatus;

    this.filterData.fieldOfStudySelectedList = _.clone(this.fieldOfStudySelectedList, true);

    this.filterData.companysize = this.companysize;
    this.filterData.companySizeSelectedList = this.companySizeSelectedList;
    this.filterData.isCompanySizeSelected = this.isCompanySizeSelected;

    this.filterData.schoolSelectedList = _.clone(this.schoolSelectedList, true);
    this.filterData.schoolLocationSelectedList = _.clone(this.schoolLocationSelectedList, true);

    this.filterData.educationSelectedList = _.clone(this.educationSelectedList, true);

    this.filterData.gender = this.gender;
    this.filterData.isGenderSelected = this.isGenderSelected;

    this.filterData.seniority = this.seniority;

    this.filterData.filterLikelyToMoveIn = this.filterLikelyToMoveIn;
    this.filterData.isLikelyToMoveInFilterSelected = this.isLikelyToMoveInFilterSelected;
    this.filterData.candidateslikelytomove = this.candidateslikelytomove;

    this.filterData.functionSelectedList = _.clone(this.functionSelectedList, true);

    this.filterData.changedJobStatus = this.changedJobStatus;
    this.filterData.changedJobStartDuration = this.changedJobStartDuration;
    this.filterData.changedJobEndDuration = this.changedJobEndDuration

    this.filterData.yearsofexperience = this.yearsofexperience;
    this.filterData.yearsofexperienceFrom = this.yearsofexperienceFrom.value;
    this.filterData.yearsofexperienceTo = this.yearsofexperienceTo.value;
    this.filterData.filterAppliedOnYearsOfExperience = this.filterAppliedOnYearsOfExperience;

    this.filterData.currentfromyearsofexperience = this.currentfromyearsofexperience.value;
    this.filterData.currenttoyearsofexperience = this.currenttoyearsofexperience.value;
    this.filterData.filterAppliedOnCurrentYearsOfExperience = this.filterAppliedOnCurrentYearsOfExperience;

    this.filterData.changedJobStatus = this.changedJobStatus;
    this.filterData.distancefromselectedlocationsmeasurementunit = this.locationDistanceUnit;
    this.filterData.distancefromselectedlocations = Number(this.locationDistanceRange);

    this.filterData.searchHistoryRegion = this.sessionStorageService.getItem("historyRegion")
   // this.filterData.keywordSelectedList = _.clone(this.keywordSelectedList, true);

  //  if (this.filterDataHandlerService.isPersonSearchListingPage()) {
      this.filterData.booleanquery = this.searchKeyword ? this.searchKeyword : '*';
   // }

    if (!this.talentInsightsReqHandler.isTalentInsightsTab) {
      this.filterData.talentdiscoveryhistoryid = globalFilterData.talentdiscoveryhistoryid;
    }
    this.filterData.fullnameSelectedList = this.fullnameSelectedList;
  }

  private syncLocalDataWithFilterObject() {
    this.jobTitleSelectedList = _.clone(this.filterData?.jobTitleSelectedList, true);
    this.jobTitleStatus = this.filterData.jobTitleStatus;

    this.pastJobTitleSelectedList = _.clone(this.filterData?.pastJobTitleSelectedList, true);

    this.skillsSelectedList = _.clone(this.filterData?.skillsSelectedList, true);

    this.locationSelectedList = _.clone(this.filterData?.locationSelectedList, true);

    this.companySelectedList = _.clone(this.filterData.companySelectedList, true);
    this.companyStatus = this.filterData.companyStatus;

    this.industrySelectedList = _.clone(this.filterData.industrySelectedList, true);
    this.industryStatus = this.filterData.industryStatus;

    this.fieldOfStudySelectedList = _.clone(this.filterData.fieldOfStudySelectedList, true);

    this.companysize = this.filterData.companysize;
    this.companySizeSelectedList = this.filterData.companySizeSelectedList;
    this.isCompanySizeSelected = this.filterData.isCompanySizeSelected;

    this.schoolSelectedList = _.clone(this.filterData.schoolSelectedList, true);
    this.schoolLocationSelectedList = _.clone(this.filterData.schoolLocationSelectedList, true);
    

    this.educationSelectedList = _.clone(this.filterData.educationSelectedList, true);

    this.gender = this.filterData.gender;
    this.isGenderSelected = this.filterData.isGenderSelected;

    this.seniority = this.filterData.seniority;

    this.filterLikelyToMoveIn = this.filterData.filterLikelyToMoveIn;
    this.isLikelyToMoveInFilterSelected = this.filterData.isLikelyToMoveInFilterSelected;
    this.candidateslikelytomove = this.filterData.candidateslikelytomove;

    this.functionSelectedList = _.clone(this.filterData.functionSelectedList, true);

    this.changedJobStatus = this.filterData.changedJobStatus;

    this.yearsofexperience = this.filterData.yearsofexperience;
    this.filterData.yearsofexperienceFrom && this.yearsofexperienceFrom.setValue(this.filterData.yearsofexperienceFrom);
    this.filterData.yearsofexperienceTo && this.yearsofexperienceTo.setValue(this.filterData.yearsofexperienceTo);

    this.filterData.currentfromyearsofexperience && this.currentfromyearsofexperience.setValue(this.filterData.currentfromyearsofexperience);
    this.filterData.currenttoyearsofexperience && this.currenttoyearsofexperience.setValue(this.filterData.currenttoyearsofexperience);

    this.keywordSelectedList = _.clone(this.filterData.keywordSelectedList, true);
  }

  private addTypeAheads(aggregatetype: string, localRequestObject: any) {
    switch (aggregatetype) {
      case "current_company": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentcompany",
          input: "",
        });
        break;
      }
      case "current_jobtitle": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentjobtitle",
          input: "",
        });
        break;
      }
      case "current_industry": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_currentindustry",
          input: "",
        });
        break;
      }
      case "location": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_location",
          input: "",
        });
        break;
      }
      case "skill": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_skills",
          input: "",
        });
        break;
      }
      case "function": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
          typeahead: "typeahead_function",
          input: "",
        });
        break;
      }
      case "school_location": {
        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
        });
        delete localRequestObject["talentdiscoveryhistoryid"];
        delete localRequestObject["calledfrom"];
        break;
      }

      
      default: {
        console.log('in default - aggregate type - ', aggregatetype);

        Object.assign(localRequestObject, {
          resultsize: 1,
          aggregatetype: aggregatetype,
        });
        delete localRequestObject["input"];
        delete localRequestObject["typeahead"];
        if (aggregatetype == "jobtitle") { localRequestObject["aggregatetype"] = this.getTableByStatus(); }
      }
    }
    delete localRequestObject["talentdiscoveryhistoryid"];
    delete localRequestObject["calledfrom"];
  }

  private getTableByStatus(): any {
    switch (this.jobTitleStatus) {
      case CallStage.CURRENT_OR_PAST.toString():
        return "jobtitle";
      case CallStage.PAST.toString():
        return "pastjobtitle";
      default:
        return "current_jobtitle";
    }
  }

  private callTypeAheadSearch(event: Event, type: string) {
    this.typeAheadSearch(event, type);
  }

  wholeNumberValidation(event){
    if(/^\d+$/.test(event.target.value)){
      this.wholeNumberForDistance = true;
    }
    else{this.wholeNumberForDistance = false;}
  }

  private setReceivedData() {
    const receivedData = this.dataService.getData();
    if (!receivedData)
      return;

    if (receivedData.calledFrom == 'advance') {
      delete receivedData?.requestObject?.fetchtotalpersoncountincontinent;
      for (let x of Object.keys(receivedData.allLists)) {
        if (!receivedData.allLists[x])
          continue;

        if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(receivedData.allLists[x]);
        } else if (x == 'currentfromyearsofexperience') {
          this.currentfromyearsofexperience.setValue(receivedData.allLists[x]);
        } else if (x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(receivedData.allLists[x]);
        } else {
          this[x] = receivedData.allLists[x];
          const keysToRemove = new Set(receivedData.allLists.contactSelectedList.map(item => item.key));
          receivedData.allLists.contactsAvailableArray = receivedData.allLists.contactsAvailableArray.filter(item => !keysToRemove.has(item.key));
        }

        if (x === 'gender') {
          this.isGenderSelected = receivedData.allLists[x]?.toLowerCase() === 'male' || receivedData.allLists[x]?.toLowerCase() === 'female';
        }

        if (x === 'companySelectedList') {
          if (receivedData.allLists[x] && receivedData.allLists[x].length) {

            const companyList = _.pluck(receivedData.allLists[x], 'key');
            this.getCompanyLogoForCompanyChips(companyList);
          }
        }
          
        if(x == 'distancefromselectedlocations' && receivedData.allLists[x] != 0){
          this.locationDistanceRange = String(receivedData.allLists[x]);
          this.locationDistanceUnit = receivedData.allLists['distancefromselectedlocationsmeasurementunit'] || 'kilometers';
          this.locationDistanceRangefromAdvance = this.locationDistanceRange;

        }
        // else if (x === 'companysize') {
        //   this.isCompanySizeSelected = receivedData?.allLists[x]?.trim()?.toLowerCase() !== 'all';
        // }
      }
    } else if (receivedData.calledFrom == 'history') {
      for (let x of Object.keys(receivedData.allLists)) {
        if (!receivedData.allLists[x])
          continue;

        if (x == 'yearsofexperienceFrom') {
          this.yearsofexperienceFrom.setValue(receivedData.allLists[x]);
        } else if (x == 'yearsofexperienceTo') {
          this.yearsofexperienceTo.setValue(receivedData.allLists[x]);
        } else if (x == 'currentfromyearsofexperience') {
          this.currentfromyearsofexperience.setValue(receivedData.allLists[x]);
        } else if (x == 'currenttoyearsofexperience') {
          this.currenttoyearsofexperience.setValue(receivedData.allLists[x]);
        } else if (x === 'gender') {
          this.isGenderSelected = receivedData.allLists[x]?.toLowerCase() === 'male' || receivedData.allLists[x]?.toLowerCase() === 'female';
          this[x] = receivedData.allLists[x];
        } else if (x == 'continentstobeincluded') {
          this.searchHistoryRegion = receivedData.allLists["continentstobeincluded"][0];
        } else {
          this[x] = receivedData.allLists[x];
        }
        if (x == 'changedjobs') {
          // if(receivedData.allLists[x] === 'no'){
          //   this.changedJobStatus = 'no';
          // }
          // else if(receivedData.allLists[x] === 'yes'){
          //   this.changedJobStatus = (receivedData.allLists['changedjobsstartdurationinmonths'] == 0) ? 'all' :'yes';
          // }
          // else{
          this.changedJobStatus = receivedData.allLists[x];
          // }
        }
        if (x == 'changedjobsstartdurationinmonths') {
          this.changedJobStartDuration = receivedData.allLists[x];
          this.changedJobDuration = receivedData.allLists[x];
        }
        if (x == 'changedjobsenddurationinmonths') {
          this.changedJobEndDuration = receivedData.allLists[x];
        }
        if (x == 'filterLikelyToMoveIn') {
          this.candidateslikelytomove = receivedData.allLists[x];
        }
        if (x === 'companySelectedList') {
          if (receivedData.allLists[x] && receivedData.allLists[x].length) {

            const companyList = _.pluck(receivedData.allLists[x], 'key');
            this.getCompanyLogoForCompanyChips(companyList);
          }
        }
        if(x == 'distancefromselectedlocations' && receivedData.allLists[x] != 0){
          this.locationDistanceRange = String(receivedData.allLists[x]);
          this.locationDistanceUnit = receivedData.allLists['distancefromselectedlocationsmeasurementunit'] || 'kilometers';
        }
        // if (x === 'companysize') {
        //   this.isCompanySizeSelected = receivedData?.allLists[x]?.trim()?.toLowerCase() !== 'all';
        // }
      }
    }
    try {
      this.yearsofexperience = !receivedData?.allLists?.yearsofexperience ? "Total" : receivedData?.allLists?.yearsofexperience;
      this.jobTitleStatus = !receivedData?.allLists?.jobTitleStatus ? CallStage.CURRENT.toString() : receivedData?.allLists?.jobTitleStatus;
      this.companyStatus = !receivedData?.allLists?.companyStatus ? CallStage.CURRENT.toString() : receivedData?.allLists?.companyStatus;
      this.industryStatus = !receivedData?.allLists?.industryStatus ? CallStage.CURRENT.toString() : receivedData?.allLists?.industryStatus;

      this.filterAppliedOnYearsOfExperience = !!receivedData?.allLists?.yearsofexperienceFrom && !!receivedData?.allLists?.yearsofexperienceTo;
      this.filterAppliedOnCurrentYearsOfExperience = !!receivedData?.allLists?.currentfromyearsofexperience && !!receivedData?.allLists?.currenttoyearsofexperience;

      this.filterData = this.filterDataHandlerService.fetchFilterData;
      setTimeout(()=> {
        this.filterDataHandlerService.emitfilterMethodObject({ methodName: ''});
      });
    } catch (error) {
      console.log('exception while setting data from data service');
      console.log(error);
    }
  }

  private setMatrixFilterData(matrixFilter: MatrixFilter) {
    if (matrixFilter.type === "gender") {
      this.gender = matrixFilter?.event?.target?.value;
      this.isGenderSelected = this.gender != 'All';
    } else if (matrixFilter.type === "likelytomovein") {
      this.filterLikelyToMoveIn = matrixFilter?.event?.target?.value;
      this.isLikelyToMoveInFilterSelected = this.filterLikelyToMoveIn === 'Yes';
      this.candidateslikelytomove = this.filterLikelyToMoveIn;
    } else if (matrixFilter.type === "changedJobs") {
      this.changedJobStatusMatrix = matrixFilter?.event?.target?.value;
      this.changedJobStartDuration = this.changedJobDuration;
      if (this.changedJobStatusMatrix === 'yes') {
        this.changedJobStatus = 'yes';
        this.changedJobEndDuration = matrixFilter?.event?.target?.endDuration;
      }
      else if (this.changedJobStatusMatrix === 'all' && this.changedJobStartDuration && this.changedJobEndDuration != 0) {
        this.changedJobStatus = 'no';
      }
      else {
        this.changedJobStatus = 'all';
      }
    }
    // We are emitting "selectedItem" event so that the pagination can be reset whenever matrix filter changes
    this.syncDataAndMakeAggregateCalls(matrixFilter.type, "selectedItem");
  }

  private syncDataAndMakeAggregateCalls(aggregateType: string, methodName?: string) {
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.shouldSendPersonSearchRequest() && this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(aggregateType);
    // We are emitting this event so that the pagination can be reset whenever matrix filter changes
    if (!!methodName) this.filterDataHandlerService.emitfilterMethodObject({methodName: methodName})
  }

  private handleYOEUpdateEvent(typeData: {
    yoeType: string;
    emmitedFrom: string;
  }) {
    if (typeData.emmitedFrom === GeneralConstants.COMPONENT_NAME.PERSON_SEARCH_FILTER)
      return;
    this.yearsofexperience = typeData.yoeType;
    this.filterDataHandlerService.setYOEType(this.yearsofexperience);

    if (GeneralConstants.YOE_TYPE.AVG === typeData.yoeType) {
      this.getAggregationReport("averageyearsofexperience");
    }
    else if (GeneralConstants.YOE_TYPE.TOTAL === typeData.yoeType) {
      this.getAggregationReport("totalyearsofexperience");
    }
  }

  private hasYOEExperienceData(): boolean {
    return typeof this.yearsofexperienceFrom?.value === "number" &&
      typeof this.yearsofexperienceTo?.value === "number" &&
      this.yearsofexperienceFrom?.value > 0 &&
      this.yearsofexperienceTo?.value > 0;
  }

  private hasCurrentYOEExperienceData(): boolean {
    return typeof this.currentfromyearsofexperience?.value === "number" &&
      typeof this.currenttoyearsofexperience?.value === "number" &&
      this.currentfromyearsofexperience?.value > 0 &&
      this.currenttoyearsofexperience?.value > 0;
  }

  showQuickSearchFilters() {
    if (this.filterType == 'skill') {
      this.skillsSelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue+'.searchastext': this.filterValue, isExcluded: false, isMandatory: false, chipkey: this.filterValue });
    } if (this.filterType == 'jobtitle') {
      this.jobTitleSelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue+'.searchastext': this.filterValue, isExcluded: false, isMandatory: false, chipkey: this.filterValue });
    } if (this.filterType == 'company') {
      this.companySelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue+'.searchastext': this.filterValue, isExcluded: false, isMandatory: false, chipkey: this.filterValue });
      this.getCompanyLogoForCompanyChips([this.filterValue]);
    } if (this.filterType == 'searchKeyword' || this.keywordInput.value) {
      this.keywordInput.patchValue(this.searchKeyword);
    } if (this.filterType == 'fullname') {
      this.fullnameSelectedList.push({ key: this.searchChips == 'SearchChips' ? this.filterValue+'.searchastext': this.filterValue, chipkey: this.filterValue });
    } if (this.searchTitle) {
      this.jobTitleSelectedList.push({ key: this.searchTitle, isExcluded: false, isMandatory: false, chipkey: this.searchTitle });
    } if(this.searchCompany) {
      this.companySelectedList.push({ key: this.searchCompany, isExcluded: false, isMandatory: false, chipkey: this.searchCompany });
    }
    //  this.aggReqObjectHandlerService.setStartIndex(0);
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    //  this.aggReqObjectHandlerService.setStartIndex(0);
    this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(this.filterType);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "addToSelectedList" });
  }

  search(event) {
    event.preventDefault();
    this.searchKeyword = this.keywordInput.value.trim();
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        keyword: this.keywordInput.value.trim()
      },
      queryParamsHandling: 'merge',
    });
    this.searchDisable = false;
    if(this.filterDataHandlerService.isRedirectFromCompanyInsightsPage || this.filterDataHandlerService.isRedirectFromTalentInsightsPage || this.similarCandidateService.isListingCalledFromSimilarCandidate || this.isReportDetails || this.isCompanyInsightsDetails) {
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata(this.filterType);
  
    }
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "searchInput" });


  }

  searchclick() {
    this.searchDisable = true;
  }

  /**
 * Check if current search (via historyid) is saved
 */
  getSavedSearchDetails() {
    this.isSearchSaved = false;
    this.personSearchService.getSaveSearchHistory(0, this.talentDiscoveryHistoryId).subscribe((res: any) => {
      if (res && res.status === 'success') {
        if (res.message && (Array.isArray(res.message) && res.message?.length)) {
          this.savedSearchDetails = res.message[0];
          this.savedSearchDetails && (this.isSearchSaved = true);
        }

      }
    });
  }

  saveSearch() {
    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "modalExtract", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = this.talentDiscoveryHistoryId;
    this.savedSearchDetails && (modalRef.componentInstance.searchName = this.savedSearchDetails?.talentdiscoveryname);
    modalRef.result
      .then((message: any) => {
        if (message && message === 'Saved successfully') {
          this.isSearchSaved = true;
          this.successMessage = 'Search saved successfully';
        }
      })
      .catch((err: any) => {
        this.errorMessage = 'Something went wrong';
      })
      .finally(() => {
        this.getSavedSearchDetails();
        setTimeout(() => {
          this.successMessage = '';
          this.errorMessage = '';
        }, 5000);
      })
  }

  selectRegion(region) {
    this.searchHistoryRegion = null;
    this.showregion = region;
    this.localstorageservice.setItem('region', region)
    this.sessionStorageService.setItem("historyRegion", null)
    this.filterDataHandlerService.setUpdatedContinent(true)
    this.syncFilterData();
    this.filterDataHandlerService.setFilterData(this.filterData);
    this.aggReqObjectHandlerService.setStartIndex(0);
    this.filterDataHandlerService.emitfilterMethodObject({ methodName: "changeContinent" });

    this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
    this.getexpandrefresheddata(this.filterType);
    this.document.documentElement.scrollTop = 0;

  }

  keyword(event) {
    if(event.target.value == "") {
      this.keywordInput.patchValue(null); this.searchKeyword = '';
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: {
          keyword: ''
        },
        queryParamsHandling: 'merge',
      });
      this.syncFilterData();
      this.filterDataHandlerService.setFilterData(this.filterData);
      this.aggReqObjectHandlerService.setStartIndex(0);
      this.aggService.getPersonSearchRecommendedCandidates(this.extraInfo);
      this.getexpandrefresheddata(this.filterType);
      this.filterDataHandlerService.emitfilterMethodObject({ methodName: "searchInput" });
    }
  }

  getExpandFilterData() {
    if (document.getElementById('collapseOne')?.classList.contains('show') && this.jobTitleSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('jobtitle')
    }

    if (document.getElementById('collapseFour')?.classList.contains('show') && this.companySelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('company')
    }
    //for past jobtitle
    if (document.getElementById('collapsePastJobTitle')?.classList.contains('show') && this.pastJobTitleSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay(this.filterNames.PAST_JOB_TITLE);
    }
    //for location
    if (document.getElementById('collapseTwo')?.classList.contains('show') && this.locationSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('location');
    }
    //for skills
    if (document.getElementById('collapseThree')?.classList.contains('show') && this.skillsSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('skills');
    }
    //for industries
    if (document.getElementById('collapseSix')?.classList.contains('show') && this.industrySelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('industry')
    }
    //for education
    if (document.getElementById('collapseTwelve')?.classList.contains('show') && this.educationSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('education');
    }
    //for school
    if (document.getElementById('collapseFourteen')?.classList.contains('show') && this.schoolSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('school');
    }
    // for field of study
    if (document.getElementById('collapseFifteen')?.classList.contains('show') && this.fieldOfStudySelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('field_of_study');
    }
    // for functions
    if (document.getElementById('collapseEighteen')?.classList.contains('show') && this.functionSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('function');
    }
    // for years of experience
    if (document.getElementById('collapseSeven')?.classList.contains('show') && this.hasYOEExperienceData()) {
      this.getFilterWiseDataToDisplay('yearsofexperience')
    }
    // for years of experience
    if (document.getElementById('collapeSevenCurrent')?.classList.contains('show') && this.hasCurrentYOEExperienceData()) {
      this.getFilterWiseDataToDisplay('currentyearsofexperience');
    }
    // for education location
    if (document.getElementById('schoollocation')?.classList.contains('show') && this.schoolLocationSelectedList.length > 0) {
      this.getFilterWiseDataToDisplay('schoollocation');
    }
  }
  
  removeTypeahead(type: any){
    const maxLength = 3
    switch (type) {
      case 'jobtitle': {
        if (!(this.jobTitleInput && this.jobTitleInput.value && this.jobTitleInput.value.length >= maxLength)) {
          this.jobTitleList = []
        }
        break;
      }
      case 'skills': {
        if (!(this.skillsInput && this.skillsInput.value && this.skillsInput.value.length >= maxLength)) {
          this.skillsList = []
        }
        break;
      }
      case 'company': {
        if (!(this.companyInput && this.companyInput.value && this.companyInput.value.length >= maxLength)) {
          this.companyList = []
        }
        break;
      }
      case 'industry': {
        if (!(this.industryInput && this.industryInput.value && this.industryInput.value.length >= maxLength)) {
          this.industryList = []
        }
        break;
      }
      case 'fieldofstudy': {
        if (!(this.fieldOfStudyInput && this.fieldOfStudyInput.value && this.fieldOfStudyInput.value.length >= maxLength)) {
          this.fieldOfStudyList = []
        }
        break;
      }
      case 'education': {
        if (!(this.educationInput && this.educationInput.value && this.educationInput.value.length >= maxLength)) {
          this.educationList = []
        }
        break;
      }
      case 'school': {
        if (!(this.schoolInput && this.schoolInput.value && this.schoolInput.value.length >= maxLength)) {
          this.schoolList = []
        }
        break;
      }
      case 'location': {
        if (!(this.locationInput && this.locationInput.value && this.locationInput.value.length >= maxLength)) {
          this.locationList = []
        }
        break;
      }
      case 'pastjobtitle': {
        if (!(this.pastJobTitleInput && this.pastJobTitleInput.value && this.pastJobTitleInput.value.length >= maxLength)) {
          this.pastJobTitleList = []
        }
        break;
      }
      case 'functions': {
        if (!(this.functionsInput && this.functionsInput.value && this.functionsInput.value.length >= maxLength)) {
          this.functionsList = []
        }
        break;
      }
      case 'schoollocation': {
        if (!(this.schoolLocationInput && this.schoolLocationInput.value && this.schoolLocationInput.value.length >= maxLength)) {
          this.schoolLocationList = []
        }
        break;
      }
    }
  }

}
